// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class PinMappingKey implements flatbuffers.IUnpackableObject<PinMappingKeyT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PinMappingKey {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPinMappingKey(bb: flatbuffers.ByteBuffer, obj?: PinMappingKey): PinMappingKey {
    return (obj || new PinMappingKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsPinMappingKey(
    bb: flatbuffers.ByteBuffer,
    obj?: PinMappingKey,
  ): PinMappingKey {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PinMappingKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  boardAddress(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  pinNum(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  static startPinMappingKey(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addBoardAddress(builder: flatbuffers.Builder, boardAddress: number) {
    builder.addFieldInt8(0, boardAddress, 0);
  }

  static addPinNum(builder: flatbuffers.Builder, pinNum: number) {
    builder.addFieldInt8(1, pinNum, 0);
  }

  static endPinMappingKey(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createPinMappingKey(
    builder: flatbuffers.Builder,
    boardAddress: number,
    pinNum: number,
  ): flatbuffers.Offset {
    PinMappingKey.startPinMappingKey(builder);
    PinMappingKey.addBoardAddress(builder, boardAddress);
    PinMappingKey.addPinNum(builder, pinNum);
    return PinMappingKey.endPinMappingKey(builder);
  }

  unpack(): PinMappingKeyT {
    return new PinMappingKeyT(this.boardAddress(), this.pinNum());
  }

  unpackTo(_o: PinMappingKeyT): void {
    _o.boardAddress = this.boardAddress();
    _o.pinNum = this.pinNum();
  }

  unpackFields(...fields: string[]): PinMappingKeyT {
    const t = new PinMappingKeyT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("board_address")) {
      t.boardAddress = this.boardAddress();
    }
    if (fieldSet.has("pin_num")) {
      t.pinNum = this.pinNum();
    }
    return t;
  }
}

export class PinMappingKeyT implements flatbuffers.IGeneratedObject {
  constructor(
    public boardAddress: number = 0,
    public pinNum: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return PinMappingKey.createPinMappingKey(builder, this.boardAddress, this.pinNum);
  }

  clone(): PinMappingKeyT {
    const obj = new PinMappingKeyT();
    obj.boardAddress = this.boardAddress;
    obj.pinNum = this.pinNum;
    return obj;
  }

  equals(other: PinMappingKeyT): boolean {
    if (this.boardAddress !== other.boardAddress) return false;
    if (this.pinNum !== other.pinNum) return false;
    return true;
  }
}

export function verifyPinMappingKey(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 1);
  } finally {
    verifier.popDepth();
  }
}
